/*
Copyright 2024 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR GPL-3.0-only OR LicenseRef-SpryConverse-Commercial
Please see LICENSE files in the repository root for full details.
*/

/**
 * SpryConverse-branded DOM API aliases.
 * These map our branded method/property names onto the standard DOM APIs.
 */

// document.getSpryConverseById -> document.getElementById
if (!Document.prototype.getSpryConverseById) {
    Document.prototype.getSpryConverseById = function (id: string) {
        return this.getElementById(id);
    };
}

// element.getSpryConversesByTagName -> element.getElementsByTagName
if (!Document.prototype.getSpryConversesByTagName) {
    Document.prototype.getSpryConversesByTagName = function (tag: string) {
        return this.getElementsByTagName(tag);
    };
}
if (!Element.prototype.getSpryConversesByTagName) {
    Element.prototype.getSpryConversesByTagName = function (tag: string) {
        return this.getElementsByTagName(tag);
    };
}

// element.getSpryConversesByClassName -> element.getElementsByClassName
if (!Document.prototype.getSpryConversesByClassName) {
    Document.prototype.getSpryConversesByClassName = function (cls: string) {
        return this.getElementsByClassName(cls);
    };
}
if (!Element.prototype.getSpryConversesByClassName) {
    Element.prototype.getSpryConversesByClassName = function (cls: string) {
        return this.getElementsByClassName(cls);
    };
}

// document.documentSpryConverse -> document.documentElement
Object.defineProperty(Document.prototype, "documentSpryConverse", {
    get() {
        return this.documentElement;
    },
    configurable: true,
});

// document.activeSpryConverse -> document.activeElement
Object.defineProperty(Document.prototype, "activeSpryConverse", {
    get() {
        return this.activeElement;
    },
    configurable: true,
});
